import namespaceHelper from '@/shared/helpers/namespace-helper';

import { namespace, PreSOJobsGetters } from './types';

const _getters = namespaceHelper.removeNamespace(namespace, PreSOJobsGetters);

export default {
  [_getters.GET_PRE_SO_JOBS_COUNT]: state => {
    return state.preSOJobCount;
  },
  [_getters.GET_PRE_SO_JOBS]: state => {
    return state.preSOJobs;
  },
  [_getters.GET_JOB_FOR_ASSIGNMENT]: state => {
    return state.jobForAssignment;
  },
  [_getters.GET_UNIT_PRE_SO_JOBS]: state => {
    return state.unitPreSOJobs;
  },
  [_getters.GET_SHOW_PRE_SO_JOBS]: state => {
    return state.showPreSOJobs;
  }
};
